import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58215b4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-base text-content py-3" }
const _hoisted_2 = { class: "flex justify-center" }


export default /*#__PURE__*/_defineComponent({
  __name: 'ProblemCancelLeavePopup',
  props: {
  modelValue: {
    type: Boolean,
    default: false,
  },
  exitPath: {
    type: String,
    default: '',
  },
  studentName: {
    type: String,
    default: '',
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const close = () => {
  emit('update:modelValue', false)
  if (props.exitPath) {
    window.location.href = props.exitPath
  }
}

return (_ctx: any,_cache: any) => {
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    title: 'Alert',
    open: __props.modelValue,
    onClose: close
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary text-white text-base w-full ml-2",
          onClick: close
        }, _toDisplayString(_ctx.$t('leave-button')), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('feedback-help-request.message-student-cancel', { studentName: __props.studentName })), 1)
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})